import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mercedesbenzrentalswithdriver() {



  const cardData =
  {
    keyword: 'Mercedes Benz Rentals with Drivers in Chennai',
    heading: 'Aaryan Travels: Mercedes Benz Rentals with Drivers in Chennai',
    headingDescription: 'Aaryan Travels offers premium Mercedes Benz Rentals with Drivers in Chennai for corporate executives, VIP guests, wedding events, and luxury travelers seeking elegance and comfort. Whether you require a chauffeur-driven Mercedes for airport transfers from Chennai International Airport, high-profile meetings in OMR or Guindy, or grand wedding entries in Nungambakkam or ECR, our luxury sedans deliver a superior travel experience. With professional chauffeurs, plush leather interiors, and on-request amenities like bottled water and Wi-Fi, Aaryan Travels ensures sophistication and convenience in every journey. For those who demand prestige on wheels, our Mercedes Benz rentals in Chennai are the perfect choice.',

    top: 'Top Places to Visit in Chennai with Aaryan Travels',

"topPlaces": [
  {
    "title": "Marina Beach",
    "description": "Marina Beach is the world’s second-longest urban beach, stretching over 13 km along the Bay of Bengal. It attracts thousands of visitors daily for morning walks, sunset views, pony rides, and local snacks like sundal and murukku. The vibrant atmosphere is filled with families, vendors, and photographers. With its golden sands and soothing waves, Marina Beach is Chennai’s most iconic coastal escape."
  },
  {
    "title": "Kapaleeshwarar Temple",
    "description": "Kapaleeshwarar Temple in Mylapore is a stunning Dravidian-style shrine dedicated to Lord Shiva and Goddess Parvati. Its towering gopuram decorated with colorful sculptures showcases rich Tamil architecture. The temple’s sacred pond and evening rituals draw devotees year-round. Cultural festivals like Panguni Peruvizha are celebrated grandly here. Kapaleeshwarar Temple is Chennai’s spiritual and cultural crown jewel."
  },
  {
    "title": "Fort St. George",
    "description": "Fort St. George, built in 1644 by the British, is the first English fortress in India and a landmark of colonial history. It now houses a museum displaying old manuscripts, weaponry, currency, and British-era artifacts. The Tamil Nadu Legislative Assembly also operates from within its walls. Its sturdy architecture and heritage charm make it fascinating to explore. Fort St. George is Chennai’s gateway to the colonial past."
  },
  {
    "title": "Santhome Basilica",
    "description": "Santhome Basilica is a neo-Gothic church built over the tomb of Saint Thomas the Apostle, making it one of only three such churches in the world. The white façade, stained glass interiors, and peaceful ambiance provide a divine experience. A small museum displays historical relics and manuscripts. Santhome Basilica is Chennai’s sacred Christian heritage treasure."
  },
  {
    "title": "Valluvar Kottam",
    "description": "Valluvar Kottam is a majestic memorial dedicated to the revered Tamil poet-saint Thiruvalluvar. Built in the shape of a grand stone chariot, it houses inscriptions of all 1,330 couplets from the Thirukkural. The enormous auditorium inside can seat over 4,000 people. Its architecture symbolizes the depth of Tamil literature. Valluvar Kottam is Chennai’s proud tribute to wisdom and culture."
  },
  {
    "title": "Guindy National Park",
    "description": "Guindy National Park is one of India’s smallest yet most biodiverse wildlife reserves located within a city. It is home to deer, blackbucks, jackals, and a variety of bird species. The adjacent Children’s Park and Snake Park make it ideal for family visits. Its shaded trails are perfect for nature walks. Guindy Park is Chennai’s refreshing pocket of wilderness."
  },
  {
    "title": "Government Museum & National Art Gallery",
    "description": "Located in Egmore, this museum is one of India’s oldest and features rare bronze idols, ancient sculptures, and archaeological findings. The National Art Gallery displays traditional paintings and cultural exhibits. Its vast collection offers deep insights into South Indian history. History lovers can spend hours exploring its galleries. It is Chennai’s treasure trove of heritage and knowledge."
  },
  {
    "title": "Elliot’s Beach (Besant Nagar Beach)",
    "description": "Elliot’s Beach is a quieter alternative to Marina, known for its clean stretch and relaxed vibes. Youngsters and families gather here in the evenings to unwind by the shore. The Karl Schmidt Memorial stands as a tribute to a brave sailor. Beachfront cafes add charm to the setting. Elliot’s Beach is Chennai’s peaceful seaside retreat."
  },
  {
    "title": "Arignar Anna Zoological Park (Vandalur Zoo)",
    "description": "Spread across 1,300 acres, Vandalur Zoo is one of the largest zoos in South Asia. It houses lions, tigers, elephants, giraffes, and exotic bird species. Safari rides, aviaries, and reptile houses offer exciting wildlife encounters. Educational tours make it a favorite among children. Vandalur Zoo is Chennai’s thrilling world of fauna and adventure."
  },
  {
    "title": "Thousand Lights Mosque",
    "description": "Thousand Lights Mosque is a magnificent Shia mosque known for its multi-domed architecture and spiritual significance. Legend says a thousand lamps were once lit to illuminate its prayer hall. The mosque glows beautifully during festivals. Its grand interiors reflect Islamic artistry. Thousand Lights Mosque is Chennai’s radiant symbol of unity and devotion."
  }
],



"services": [
  {
    "name": "Mercedes Benz Rentals with Drivers in Chennai",
    "description": "Mercedes Benz Rentals with Drivers in Chennai offer premium chauffeur-driven Mercedes vehicles for a range of occasions, including corporate travel, weddings, and special events. The service guarantees luxury, comfort, and professionalism, with drivers trained to provide courteous and timely transportation tailored to your needs."
  },
  {
    "name": "Chauffeur Driven Mercedes Chennai",
    "description": "Chauffeur Driven Mercedes Chennai provides a fleet of luxurious Mercedes cars accompanied by professional chauffeurs. Perfect for business executives and VIPs, this service emphasizes punctuality, privacy, and seamless travel experiences across Chennai."
  },
  {
    "name": "Mercedes Cab Hire Chennai",
    "description": "Mercedes Cab Hire Chennai specializes in offering stylish and sophisticated Mercedes cabs for hire. Whether for airport transfers, corporate meetings, or city tours, customers can enjoy a reliable and comfortable ride with well-maintained vehicles."
  },
  {
    "name": "Executive Mercedes Rentals Chennai",
    "description": "Executive Mercedes Rentals Chennai cater to corporate clients seeking high-end transportation solutions. With premium Mercedes models and experienced drivers, this service ensures a professional image and luxurious travel for business needs."
  },
  {
    "name": "Premium Mercedes Taxi Chennai",
    "description": "Premium Mercedes Taxi Chennai delivers luxury taxi services featuring top Mercedes models. Ideal for discerning travelers who demand comfort and exclusivity, this service combines elegance with efficiency for city-wide transportation."
  },
  {
    "name": "Luxury Mercedes SUV Chennai",
    "description": "Luxury Mercedes SUV Chennai offers spacious and stylish Mercedes SUVs for families, corporate groups, and special occasions. These vehicles provide enhanced comfort, ample space, and premium features with professional chauffeur service."
  },
  {
    "name": "Mercedes Sedan Rental Chennai",
    "description": "Mercedes Sedan Rental Chennai provides a selection of elegant Mercedes sedans for rent with professional chauffeurs. This service is ideal for executive travel, client pickups, and luxury city rides, ensuring sophistication and reliability."
  },
  {
    "name": "Corporate Mercedes Services Chennai",
    "description": "Corporate Mercedes Services Chennai specialize in offering tailored Mercedes transportation solutions for businesses. From regular office commutes to client hospitality, this service provides punctual and premium travel experiences."
  },
  {
    "name": "Affordable Mercedes Hire Chennai",
    "description": "Affordable Mercedes Hire Chennai combines luxury with cost-effective pricing, allowing clients to enjoy premium Mercedes vehicles without overspending. Suitable for startups, SMEs, and individuals seeking value in upscale travel."
  },
  {
    "name": "Mercedes Benz Chauffeur Chennai",
    "description": "Mercedes Benz Chauffeur Chennai features trained drivers who provide discreet and courteous service, enhancing every ride with professionalism and attention to detail. Perfect for business travelers and VIP clients."
  },
  {
    "name": "Online Mercedes Booking Chennai",
    "description": "Online Mercedes Booking Chennai offers a convenient digital platform for reserving Mercedes vehicles with chauffeurs. Clients can easily schedule rides, manage bookings, and receive instant confirmations for hassle-free luxury travel."
  },
  {
    "name": "Wedding Mercedes Cab Chennai",
    "description": "Wedding Mercedes Cab Chennai specializes in providing luxurious Mercedes cars for weddings and related events. The service ensures elegant transportation for the bridal party, guests, and key moments, complemented by professional chauffeurs."
  },
  {
    "name": "Best Mercedes Cab Chennai",
    "description": "Best Mercedes Cab Chennai is renowned for its exceptional fleet quality, timely service, and professional drivers. Clients can trust this service for flawless luxury transportation tailored to diverse needs."
  },
  {
    "name": "Business Class Mercedes Chennai",
    "description": "Business Class Mercedes Chennai offers executive-level transportation with premium Mercedes vehicles designed to meet corporate standards. This service focuses on comfort, reliability, and professionalism for business travelers."
  },
  {
    "name": "Mercedes Event Transport Chennai",
    "description": "Mercedes Event Transport Chennai provides specialized Mercedes vehicle rentals for corporate events, social gatherings, and VIP occasions. With attention to detail and superior service, it ensures seamless luxury transport tailored to event schedules."
  }
],
"tableData": [
  ["Mercedes Benz Rentals with Drivers in Chennai", "Chauffeur Driven Mercedes Chennai"],
  ["Mercedes Cab Hire Chennai", "Executive Mercedes Rentals Chennai"],
  ["Premium Mercedes Taxi Chennai", "Luxury Mercedes SUV Chennai"],
  ["Mercedes Sedan Rental Chennai", "Corporate Mercedes Services Chennai"],
  ["Affordable Mercedes Hire Chennai", "Mercedes Benz Chauffeur Chennai"],
  ["Online Mercedes Booking Chennai", "Wedding Mercedes Cab Chennai"],
  ["Best Mercedes Cab Chennai", "Business Class Mercedes Chennai"],
  ["Mercedes Event Transport Chennai", "—"]
],


"whychoose": [
  {
    "WhyChooseheading": "Mercedes Benz Rentals with Drivers in Chennai",
    "WhyChoosedescription": "Aaryan Travels offers premium Mercedes Benz rentals with professional drivers in Chennai, combining luxury and convenience."
  },
  {
    "WhyChooseheading": "Wide Range of Mercedes Benz Vehicles",
    "WhyChoosedescription": "Choose from our fleet of well-maintained Mercedes Benz cars perfect for business, airport transfers, and special occasions."
  },
  {
    "WhyChooseheading": "Experienced and Courteous Drivers",
    "WhyChoosedescription": "Our professional chauffeurs provide punctual, safe, and discreet service to enhance your travel experience."
  },
  {
    "WhyChooseheading": "Sanitized and Comfortable Cars",
    "WhyChoosedescription": "All vehicles are regularly cleaned and maintained to ensure hygiene and passenger comfort."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Fees",
    "WhyChoosedescription": "Benefit from upfront pricing inclusive of fuel, tolls, and driver allowances without any surprise charges."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our dedicated support team is available around the clock to assist with bookings and travel inquiries."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans Tailored to Your Needs",
    "WhyChoosedescription": "Customize your Mercedes Benz rental with driver based on hourly, daily, or long-term rental options."
  },
  {
    "WhyChooseheading": "Reliable and Timely Service Across Chennai",
    "WhyChoosedescription": "We ensure prompt pickups and drop-offs anywhere in Chennai for a seamless luxury travel experience."
  }
]















  }

const faqData = [
  {
    question: 'Does Aaryan Travels offer Mercedes Benz rentals with drivers in Chennai?',
    answer: 'Yes, Aaryan Travels provides premium Mercedes Benz rentals with professional drivers in Chennai for a luxurious and comfortable ride.',
  },
  {
    question: 'How can I book Mercedes Benz rentals with drivers in Chennai?',
    answer: 'You can easily book through our website, mobile app, or by contacting our 24x7 customer support team in Chennai.',
  },
  {
    question: 'What models of Mercedes Benz are available for rental with drivers in Chennai?',
    answer: 'Aaryan Travels offers a range of Mercedes Benz models including E-Class, S-Class, and luxury SUVs tailored for your needs in Chennai.',
  },
  {
    question: 'Are the drivers experienced and trained for Mercedes Benz rentals in Chennai?',
    answer: 'Absolutely. Our drivers are professionally trained, punctual, and committed to providing a premium driving experience.',
  },
  {
    question: 'Can Mercedes Benz rentals with drivers be booked for corporate and personal use in Chennai?',
    answer: 'Yes, these rentals are ideal for corporate travel, airport transfers, weddings, and special occasions in Chennai.',
  },
  {
    question: 'Is the Mercedes Benz rental service with drivers available 24x7 in Chennai?',
    answer: 'Yes, Aaryan Travels offers round-the-clock Mercedes Benz rental services with drivers to suit your schedule in Chennai.',
  },
  {
    question: 'Are hygiene and safety protocols followed for Mercedes Benz rentals?',
    answer: 'All vehicles are sanitized thoroughly, and drivers adhere to strict safety and hygiene standards for your comfort and safety.',
  },
  {
    question: 'What payment options are accepted for Mercedes Benz rentals with drivers in Chennai?',
    answer: 'We accept payments via UPI, credit/debit cards, digital wallets, bank transfers, and corporate accounts.',
  },
  {
    question: 'Is customer support available during the Mercedes Benz rental period in Chennai?',
    answer: 'Yes, our 24x7 customer support team is available to assist you throughout your rental experience.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Ramesh Iyer',
    feedback: 'Aaryan Travels provided excellent Mercedes Benz rental with a professional driver in Chennai. The experience was top-notch.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Latha Krishnan',
    feedback: 'Highly recommend Aaryan Travels for Mercedes Benz rentals with drivers in Chennai. The service was smooth and luxurious.',
    rating: 5,
  },
];

























































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Best Cab Services in Pune", link: "best-cab-services-in-pune" },
    { place: "/images/keyword/3.jpg", text: "Best Cab Services in Kochi", link: "best-cab-services-in-kochi" },
    { place: "/images/keyword/4.jpg", text: "Cab booking from Mumbai to Pune", link: "cab-booking-from-mumbai-to-pune" },
    { place: "/images/keyword/5.jpg", text: "Cab from Pune to Mahabaleshwar", link: "cab-from-pune-to-mahabaleshwar" },
    { place: "/images/keyword/6.jpg", text: "Monthly Cab hire contract in Hyderabad", link: "monthly-cab-hire-contract-in-hyderabad" },
    { place: "/images/keyword/7.jpg", text: "Taxi Services from Pune to Shirdi", link: "taxi-services-from-pune-to-shirdi" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Pune Corporate Cab", link: "mumbai-to-pune-corporate-cab" },
    { place: "/images/keyword/10.jpg", text: "Outstation Cab Services from Pune", link: "outstation-cab-services-from-pune" },
    { place: "/images/keyword/11.jpg", text: "Innova Crysta rental in Pune", link: "innova-crysta-rental-in-pune" },
    { place: "/images/keyword/12.jpg", text: "Corporate Cab hire in Pune", link: "corporate-cab-hire-in-pune" },
    { place: "/images/keyword/13.jpg", text: "Pune to Shirdi Corporate Cab booking", link: "pune-to-shirdi-corporate-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Corporate Cab Services", link: "pune-to-mumbai-corporate-cab-services" },
    { place: "/images/keyword/15.jpg", text: "Monthly Corporate Cab rental in Chennai", link: "monthly-corporate-cab-rental-in-chennai" },
    { place: "/images/keyword/16.jpg", text: "Wedding Corporate Cab bookings in Pune", link: "wedding-cab-bookings-in-pune" },
    { place: "/images/keyword/17.jpg", text: "Corporate Cab Services in Kharadi, Pune", link: "corporate-cab-services-in-kharadi-pune" },
    { place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranchi", link: "corporate-cab-services-in-ranchi" },
    { place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Vadodara", link: "corporate-cab-services-in-vadodara" },
    { place: "/images/keyword/20.jpg", text: "Corporate Cab booking in Ranchi", link: "corporate-cab-booking-in-ranchi" },
    { place: "/images/keyword/21.jpg", text: "Corporate Cab booking in Vadodara", link: "corporate-cab-booking-in-vadodara" },
    { place: "/images/keyword/22.jpg", text: "Taxi booking in Ranchi", link: "taxi-booking-in-ranchi" },
    { place: "/images/keyword/23.jpg", text: "Corporate Cab Services in India", link: "corporate-cab-services-in-india" },
    { place: "/images/keyword/24.jpg", text: "Taxi Services in Vadodara, Gujarat", link: "taxi-services-in-vadodara-gujarat" },
    { place: "/images/keyword/25.jpg", text: "Taxi booking in Vadodara", link: "taxi-booking-in-vadodara" }
  ];





const mercedesChennaiSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Mercedes Benz Rentals with Drivers in Chennai",
  "description": "Aaryan Travels offers chauffeur-driven Mercedes Benz rentals in Chennai including executive sedans, luxury SUVs, wedding cabs, corporate and business transport services.",
  "provider": {
    "@type": "Organization",
    "name": "Aaryan Travels",
    "url": "https://aaryantravels.com"
  },
  "areaServed": {
    "@type": "City",
    "name": "Chennai"
  },
  "serviceType": "Mercedes Benz Cab Rental Service",
  "keywords": "Mercedes Benz Rentals with Drivers in Chennai, Chauffeur Driven Mercedes Chennai, Mercedes Cab Hire Chennai, Executive Mercedes Rentals Chennai, Premium Mercedes Taxi Chennai, Luxury Mercedes SUV Chennai, Mercedes Sedan Rental Chennai, Corporate Mercedes Services Chennai, Affordable Mercedes Hire Chennai, Mercedes Benz Chauffeur Chennai, Online Mercedes Booking Chennai, Wedding Mercedes Cab Chennai, Best Mercedes Cab Chennai, Business Class Mercedes Chennai, Mercedes Event Transport Chennai"
};









  return (
    <div>

<Helmet>
  <title>Mercedes Benz Rentals with Drivers in Chennai | Chauffeur Driven Mercedes | Aaryan Travels</title>
  <meta
    name="description"
    content="Book chauffeur-driven Mercedes Benz rentals in Chennai with Aaryan Travels. Executive sedans, luxury SUVs, corporate, wedding, and business transport services available."
  />
  <meta
    name="keywords"
    content="Mercedes Benz Rentals with Drivers in Chennai, Chauffeur Driven Mercedes Chennai, Mercedes Cab Hire Chennai, Executive Mercedes Rentals Chennai, Premium Mercedes Taxi Chennai, Luxury Mercedes SUV Chennai, Mercedes Sedan Rental Chennai, Corporate Mercedes Services Chennai, Affordable Mercedes Hire Chennai, Mercedes Benz Chauffeur Chennai, Online Mercedes Booking Chennai, Wedding Mercedes Cab Chennai, Best Mercedes Cab Chennai, Business Class Mercedes Chennai, Mercedes Event Transport Chennai"
  />
  <script type="application/ld+json">
    {JSON.stringify(mercedesChennaiSchema)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-3" data-cursor="-opaque">
                   {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>










      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/90.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaryan Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaryan Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919730707888" className="pc-call">+91 9730707888</a>
                      <a href="tel:+919833377051" className="pc-call">+91 9833377051</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919730707888"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919730707888" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:bookings@aaryantravels.com" className="pc-email">
                      bookings@aaryantravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aryan Travels Pune Head Office</strong><br />
                      Flat 304, Plot-82, Prathmesh Krupa, Purnanagar/Chikhali Pune- 411019.
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mercedesbenzrentalswithdriver;